import React from 'react'
import * as S from './styled'
import { StyledIcon } from '@styled-icons/styled-icon'

interface StepProps {
  label: string
  icon?: React.ReactComponentElement<StyledIcon>
}

export const Step: React.FC<StepProps> = ({ label, children, icon }) => {
  return (
    <S.Step>
      <S.StepIcon>{icon}</S.StepIcon>
      <S.StepContent>
        <S.StepLabel>{label}</S.StepLabel>
        {children}
      </S.StepContent>
    </S.Step>
  )
}

export const Stepper = S.Stepper
